// extracted by mini-css-extract-plugin
export default {"wrap":"SatisfactionItems_wrap__fPk4m","link":"SatisfactionItems_link__JqrvS"};